if (!customElements.get('model-parts')) {
  class ComponentModelParts extends HTMLElement {
    constructor() {
      super();
      this.searchForm = this.querySelector('#search-parts-form');
      this.searchField = this.searchForm ? this.searchForm.querySelector('input[name="part"]') : false;
      if(this.searchField != false){
        this.searchTargets = this.querySelectorAll('.search-target');
        this.quickViewBtns = this.querySelectorAll('.quick-view-trigger')
        this.quickViewBtns.forEach((item) => {
          item.addEventListener('click', this.openQuickView.bind(this))
        });
        this.partRows = this.querySelectorAll('#parts-list .part-row');
        this.allSelectPart = this.querySelectorAll('#parts-list .select-part');
        this.atcStickyPanel = this.querySelector('atc-sticky-panel');
        this.invalidWarrantyMessage = this.dataset.invalidWarrantyMessage;
        
        this.addToCartBtn = this.atcStickyPanel.querySelector('.btn.add');
        this.clearBtn = this.atcStickyPanel.querySelector('.clear-selections');
        
        this.quantityToAdd = 0;
        this.totalPrice = 0;
        
        this.allSelectPart.forEach((item) => {
          var check = item.querySelector('.select-part-check');
          check.addEventListener('change', this.onCheck.bind(this));

          var qtyField = item.querySelector('.quantity-input');
          qtyField.addEventListener('change', this.updateQuantityToAdd.bind(this));
        });

        this.searchForm.addEventListener('submit', this.doSearch.bind(this));
        this.searchField.addEventListener('input', this.doSearch.bind(this));

        this.addToCartBtn.addEventListener('click', this.addToCart.bind(this));

        this.clearBtn.addEventListener('click', this.clearSelections.bind(this));

        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('email') && urlParams.has('registrationId')) {
          var email = decodeURIComponent(urlParams.get('email'));
          var registrationId = decodeURIComponent(urlParams.get('registrationId'))/1;
          // Scope the optimistic $0 (union across same-model grills) down to the
          // grill in the URL BEFORE tagging, so a part another grill covers but
          // this one does not shows its real price and is never tagged free.
          this.scopeToRegistration(registrationId);
          this.verifyWarranty(email, registrationId);
        }

        this.toggleAtcStickyPanel();
        this.initAutoRefresh();
      }
    }

    initAutoRefresh() {
      // After the buyer returns to this tab (e.g. from placing an order) or
      // navigates back to it, re-render from the server so claimed parts show
      // their real price and can't be claimed again, without a manual refresh.
      // Reloads only after a real away period, throttled to avoid tab-flick reloads.
      var THROTTLE_MS = 15000;
      var MIN_AWAY_MS = 2500;
      var hiddenAt = 0;
      function canReload() {
        var last = 0;
        try { last = parseInt(sessionStorage.getItem('wssPartsReloadTs') || '0', 10) || 0; } catch (e) {}
        if (Date.now() - last < THROTTLE_MS) return false;
        try { sessionStorage.setItem('wssPartsReloadTs', String(Date.now())); } catch (e) {}
        return true;
      }
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') { hiddenAt = Date.now(); return; }
        if (hiddenAt && (Date.now() - hiddenAt) >= MIN_AWAY_MS && canReload()) {
          window.location.reload();
        }
      });
      window.addEventListener('pageshow', function (e) {
        if (e.persisted && canReload()) { window.location.reload(); }
      });
    }

    noValidWarranty() {
      $s.hideLoadingOverlay();

      this.querySelector('.parts').innerHTML = '<div class="text-center">' + lngg.model_parts__warranty_invalid_message + '</div>';
    }

    readJsonMap(selector) {
      var el = document.querySelector(selector);
      if (!el) { return {}; }
      try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; }
    }

    // Re-render each row for the ONE grill in the URL. The server marks a row $0
    // (eligible) or "Already claimed" using a union across every same-model grill,
    // but each is per-grill: the cart line is tagged with this registration and
    // the discount function + claim ledger are per-grill (claim.used already
    // reflects same-serial cross-blocking). So a part another grill claimed must
    // not read "Already claimed" here, and a part this grill covers must read $0.
    scopeToRegistration(registrationId) {
      var eligibleMap = this.readJsonMap('[data-wss-reg-eligibility]');
      var claimedMap = this.readJsonMap('[data-wss-reg-claimed]');
      var key = String(registrationId);
      var grillEligible = eligibleMap[key] || '';
      var grillClaimed = claimedMap[key] || '';

      var eligibleHere = 0;
      this.partRows.forEach((row) => {
        var pid = row.dataset.pid || '';
        if (!pid) { return; }

        var token = '|' + pid + '|';
        var isEligible = grillEligible.indexOf(token) !== -1;
        var isClaimedHere = grillClaimed.indexOf(token) !== -1;
        var priceEls = row.querySelectorAll('.part-price');
        var qty = row.querySelector('.quantity-input');
        var claimedTags = row.querySelectorAll('.part-claimed-tag');

        if (isEligible) {
          // Free for this grill: $0, no claimed tag, taggable for the cart.
          eligibleHere++;
          row.dataset.eligible = 'true';
          row.dataset.claimed = 'false';
          priceEls.forEach((el) => { el.textContent = '$0.00'; });
          if (qty) { qty.dataset.unitPrice = '0'; }
          claimedTags.forEach((t) => { t.style.display = 'none'; });
        } else {
          // Not free for this grill: real price, never tagged.
          row.dataset.eligible = 'false';
          row.dataset.claimed = isClaimedHere ? 'true' : 'false';
          if (row.dataset.actualPrice) {
            priceEls.forEach((el) => { el.textContent = row.dataset.actualPrice; });
          }
          if (qty && row.dataset.actualCents) { qty.dataset.unitPrice = row.dataset.actualCents; }
          // Show "Already claimed" ONLY if THIS grill claimed it.
          claimedTags.forEach((t) => { t.style.display = isClaimedHere ? '' : 'none'; });
        }
      });

      // Clicked grill covers nothing (used up in one-claim mode): show the banner.
      if (eligibleHere === 0) {
        var banner = this.querySelector('[data-wss-claimed-banner]');
        if (banner) { banner.style.display = ''; }
      }
    }

    verifyWarranty(email, registrationId) {
      if (!registrationId) { return; }

      this.partRows.forEach((item) => {
        if (item.dataset.claimed === 'true') { return; }
        // Honor the server-rendered eligibility (metafield -> CustomerVue
        // flag). Do NOT call the legacy browser warranty endpoint; it is
        // blocked by CORS and the app sync is now the eligibility source.
        if (item.dataset.eligible !== 'true') { return; }

        var selectPart = item.querySelector('.select-part');
        if (!selectPart) { return; }

        if (!selectPart.querySelector('.valid-warranty')) {
          var inputValidity = document.createElement('input');
          inputValidity.type = 'hidden';
          inputValidity.dataset.name = `items[${item.dataset.index}][properties][_valid_warranty]`;
          inputValidity.classList.add('valid-warranty');
          inputValidity.value = String(registrationId);
          selectPart.appendChild(inputValidity);
        }

        if (!selectPart.querySelector('.wss-registration-id')) {
          var inputReg = document.createElement('input');
          inputReg.type = 'hidden';
          inputReg.dataset.name = `items[${item.dataset.index}][properties][_wss_registration_id]`;
          inputReg.classList.add('wss-registration-id');
          inputReg.value = String(registrationId);
          selectPart.appendChild(inputReg);
        }
      });
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = e.target.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    doSearch(e) {
      e.preventDefault();
      e.stopPropagation();

      var term = this.searchField.value;
      this.searchTargets.forEach((item) => {
        if(term == "" || item.innerHTML.toLowerCase().includes(term.toLowerCase())){
          item.closest('.table-row').style.display = '';
        }else{
          item.closest('.table-row').style.display = 'none';
        }
      });
    }

    onCheck(e) {
      const item = e.target.closest('.select-part');
      const qtyField = item.querySelector('.quantity-input');
      const variantIdField = item.querySelector('.variant-id');
      const enabled = e.target.checked;
      
      if(enabled) {
        item.closest('.select-part').querySelector('.quantity-box').classList.remove('hide');
        qtyField.removeAttribute('disabled');
        qtyField.setAttribute('name', qtyField.dataset.name);
        variantIdField.removeAttribute('disabled');
        variantIdField.setAttribute('name', variantIdField.dataset.name);
        var maxQtyField = item.querySelector('.max-qty');
        maxQtyField.removeAttribute('disabled');
        maxQtyField.setAttribute('name', maxQtyField.dataset.name);

        var validWarrantyField = item.querySelector('.valid-warranty');
        if(validWarrantyField) {
          validWarrantyField.removeAttribute('disabled');
          validWarrantyField.setAttribute('name', validWarrantyField.dataset.name);
        }
        var regIdField = item.querySelector('.wss-registration-id');
        if(regIdField) {
          regIdField.removeAttribute('disabled');
          regIdField.setAttribute('name', regIdField.dataset.name);
        }
      } else {
        item.closest('.select-part').querySelector('.quantity-box').classList.add('hide');
        qtyField.setAttribute('disabled', true);
        qtyField.removeAttribute('name');
        variantIdField.setAttribute('disabled', true);
        variantIdField.removeAttribute('name');
        var maxQtyField = item.querySelector('.max-qty');
        maxQtyField.setAttribute('disabled', true);
        maxQtyField.removeAttribute('name');
        var validWarrantyField = item.querySelector('.valid-warranty');
        if(validWarrantyField) {
          validWarrantyField.setAttribute('disabled', true);
          validWarrantyField.removeAttribute('name');
        }
        var regIdField = item.querySelector('.wss-registration-id');
        if(regIdField) {
          regIdField.setAttribute('disabled', true);
          regIdField.removeAttribute('name');
        }
      }

      this.updateQuantityToAdd();
      this.toggleAtcStickyPanel();
    }

    updateQuantityToAdd(e) {
      this.totalPrice = 0;
      this.quantityToAdd = 0;
      this.allSelectPart.forEach((item) => {
        if(!item.querySelector('.quantity-input').disabled) {
          this.quantityToAdd = this.quantityToAdd + item.querySelector('.quantity-input').value * 1;
          this.totalPrice = this.totalPrice + item.querySelector('.quantity-input').value * item.querySelector('.quantity-input').dataset.unitPrice;
        }
      });
      this.atcStickyPanel.querySelector('#total-qty').innerHTML = this.quantityToAdd;

      this.atcStickyPanel.querySelector('.btn.add .total-price').innerHTML = $s.formatMoney(this.totalPrice);
    }

    toggleAtcStickyPanel() {
      if (this.quantityToAdd > 0) {
        this.atcStickyPanel.classList.add('open');
      } else {
        this.atcStickyPanel.classList.remove('open');
      }
    }

    addToCart(e) {
      this.clearBtn.click();
    }

    clearSelections(e) {
      this.allSelectPart.forEach((item) => {
        var check = item.querySelector('.select-part-check');
        var qtyField = item.querySelector('.quantity-input');
        var variantIdField = item.querySelector('.variant-id');
        check.checked = false;
        item.closest('.select-part').querySelector('.quantity-box').classList.add('hide');
        qtyField.setAttribute('disabled', true);
        qtyField.removeAttribute('name');
        variantIdField.setAttribute('disabled', true);
        variantIdField.removeAttribute('name');
        // Also release the property fields. Otherwise a previously selected
        // part keeps items[i][properties][...] named with no items[i][id],
        // and the next add-to-cart fails with "Required parameter missing or
        // invalid: id".
        var maxQtyField = item.querySelector('.max-qty');
        if (maxQtyField) {
          maxQtyField.setAttribute('disabled', true);
          maxQtyField.removeAttribute('name');
        }
        var validWarrantyField = item.querySelector('.valid-warranty');
        if (validWarrantyField) {
          validWarrantyField.setAttribute('disabled', true);
          validWarrantyField.removeAttribute('name');
        }
        var regIdField = item.querySelector('.wss-registration-id');
        if (regIdField) {
          regIdField.setAttribute('disabled', true);
          regIdField.removeAttribute('name');
        }
      });
      this.updateQuantityToAdd();
      this.toggleAtcStickyPanel();
    }

  }
  customElements.define('model-parts', ComponentModelParts);
}
